import React, { useState } from "react";
import CustomButton from "../CustomButton";
import CustomSelect from "../CustomSelect";
import ModalLayout from "../layouts/ModalLayout";
import CustomInput from "../CustomInput";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import ClassSelect from "../common-input/ClassSelect";

interface Props {
  onClose?: () => void;
  onSuccess?: (date: string, classId: number) => void;
}

function AttendanceReportByDate({ onClose, onSuccess }: Props) {
  const { classes } = useSelector((state: RootState) => state.classes);

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [selectedClassId, setSelectedClassId] = useState<number | "">("");

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;

    if (name === "date") {
      setDate(value);
    }

    if (name === "classId") {
      setSelectedClassId(Number(value));
    }
  };

  const handleView = (e: React.FormEvent) => {
    e.preventDefault();

    if (!date || !selectedClassId) return;

    onSuccess?.(date, Number(selectedClassId));
    onClose?.();
  };

  return (
    <ModalLayout onClose={onClose}>
      <form className="flex flex-col gap-8 max-w-xl" onSubmit={handleView}>
        <h3 className="text-xl font-semibold text-neutral-400">
          View Attendance Report - Date Wise
        </h3>

        <CustomInput
          name="date"
          label="Date"
          type="date"
          value={date}
          onChange={handleInputChange}
          inputClassName="w-full"
        />

        <ClassSelect
          name="classId"
          label="Class"
          value={selectedClassId}
          placeholder="Select Class"
          onChange={handleInputChange}
        />

        <div className="flex justify-end gap-5">
          <CustomButton
            type="button"
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <CustomButton type="submit" color="bg-success-600" text="View" />
        </div>
      </form>
    </ModalLayout>
  );
}

export default AttendanceReportByDate;
